export function EndConference() {
  return (
    <div className="bg-stone-900 flex justify-center items-center h-screen w-screen">
      <p className="text-white font-bold text-2xl">
        Merci d'avoir participer !
      </p>
    </div>
  );
}
